/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const Slice = createSlice({
  name: 'groupsList',
  initialState: {
    groupsList: ['Rep group 1'],
    groups: {
      'Rep group 1': {
        isTabExpended: true,
        rules: {
          routingRules: [],
        },
        groupAvailability: {
          hourFormat: '12h',
          data: {
            Monday: { from: 8, to: 15, option: 'custom' },
            Tuesday: { from: 8, to: 15, option: 'close' },
            Wednesday: { from: 8, to: 15, option: 'open' },
            Thursday: { from: 8, to: 15, option: 'open' },
            Friday: { from: 8, to: 15, option: 'open' },
            Saturday: { from: 8, to: 15, option: 'open' },
            Sunday: { from: 8, to: 15, option: 'open' },
          },
        },
        scheduler: {
          Monday: {
            'Fresh Leads': { from: 8, to: 10, active: 'true' },
            'After Hour Leads': { from: 9, to: 13, active: 'true' },
            Reattempts: { from: 10, to: 12, active: false },
          },
          Tuesday: {
            'Fresh Leads': { from: 8, to: 10, active: 'true' },
            'After Hour Leads': { from: 9, to: 13, active: 'true' },
            Reattempts: { from: 10, to: 12, active: false },
          },
          Wednesday: {
            'Fresh Leads': { from: 8, to: 10, active: 'true' },
            'After Hour Leads': { from: 9, to: 13, active: 'true' },
            Reattempts: { from: 10, to: 12, active: false },
          },
          Thursday: {
            'Fresh Leads': { from: 8, to: 10, active: 'true' },
            'After Hour Leads': { from: 9, to: 13, active: 'true' },
            Reattempts: { from: 10, to: 12, active: false },
          },
          Friday: {
            'Fresh Leads': { from: 8, to: 10, active: 'true' },
            'After Hour Leads': { from: 9, to: 13, active: 'true' },
            Reattempts: { from: 10, to: 12, active: false },
          },
          Saturday: {
            'Fresh Leads': { from: 8, to: 10, active: 'true' },
            'After Hour Leads': { from: 9, to: 13, active: 'true' },
            Reattempts: { from: 10, to: 12, active: false },
          },
          Sunday: {
            'Fresh Leads': { from: 8, to: 10, active: 'true' },
            'After Hour Leads': { from: 9, to: 13, active: 'true' },
            Reattempts: { from: 10, to: 12, active: false },
          },
        },
      },
    },
  },
  reducers: {
    setTabExpend: (state, action) => {
      const { groups } = state;
      groups[action.payload.groupName].isTabExpended = !groups[action.payload.groupName].isTabExpended;
    },
    setHourFormat: (state, action) => {
      const { groups } = state;
      groups[action.payload.groupName].groupAvailability.hourFormat = action.payload.value;
    },
    setGroupAvailabilityData: (state, action) => {
      const { groups } = state;
      const { groupAvailability } = groups[action.payload.groupName];
      groupAvailability.data = {
        ...groupAvailability.data,
        ...action.payload.value,
      };
    },
    setSchedulerData: (state, action) => {
      const { groups } = state;
      const { scheduler } = groups[action.payload.groupName];
      groups[action.payload.groupName].scheduler[action.payload.selectedDay] = {
        ...scheduler[action.payload.selectedDay],
        ...action.payload.value,
      };
    },
  },
});

export const { setTabExpend, setHourFormat, setGroupAvailabilityData, setSchedulerData } = Slice.actions;
export default Slice.reducer;
